import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const borderAnimation = keyframes`
  0% {
    width: 0;
    height: 0;
    opacity: 0;
  }
  50% {
    width: 100%;
    height: 0;
    opacity: 1;
  }
  100% {
    width: 100%;
    height: 100%;
    opacity: 1;
  }
`;

export const LoginContainer = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Courier New', monospace;
  position: relative;
`;

export const LoginForm = styled.form`
  background: white;
  padding: 48px;
  width: 100%;
  max-width: 400px;
  position: relative;
  animation: ${slideIn} 0.6s ease-out;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #c41e3a;
    animation: ${borderAnimation} 1s ease-out forwards;
    pointer-events: none;
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 32px;
  text-align: center;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: normal;
  animation: ${fadeIn} 0.6s ease-out;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 2px;
    background: #c41e3a;
  }
`;

const inputAnimation = keyframes`
  from {
    transform: translateX(-10px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const InputGroup = styled.div`
  position: relative;
  margin-bottom: 24px;
  animation: ${inputAnimation} 0.6s ease-out;
  animation-delay: ${props => props.delay || '0s'};
  opacity: 0;
  animation-fill-mode: forwards;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  background: transparent;
  border: none;
  border-bottom: 1px solid #000;
  font-size: 1rem;
  font-family: 'Courier New', monospace;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #c41e3a;
  }

  &::placeholder {
    color: transparent;
  }

  &:focus + label,
  &:not(:placeholder-shown) + label {
    transform: translateY(-20px);
    font-size: 0.8rem;
    color: #c41e3a;
  }
`;

export const Label = styled.label`
  position: absolute;
  left: 12px;
  top: 12px;
  color: #666;
  font-size: 1rem;
  transition: all 0.3s ease;
  pointer-events: none;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

const buttonAnimation = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 16px;
  background: #000;
  color: white;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-family: 'Courier New', monospace;
  transition: all 0.3s ease;
  margin-top: 32px;
  position: relative;
  overflow: hidden;
  animation: ${buttonAnimation} 0.6s ease-out;
  animation-delay: 0.6s;
  opacity: 0;
  animation-fill-mode: forwards;

  &:hover {
    background: #c41e3a;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 120%;
    height: 0;
    padding-bottom: 120%;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.5s ease-out;
  }

  &:hover::after {
    transform: translate(-50%, -50%) scale(1);
  }
`;

export const ErrorMessage = styled.p`
  color: #c41e3a;
  margin: 16px 0;
  text-align: center;
  font-size: 0.9rem;
  letter-spacing: 0.05em;
  animation: ${fadeIn} 0.3s ease-out;
`; 